import { useEffect } from 'react';
import pushNotificationService from '../services/pushNotificationService';
import { pushTokenAPI } from '../services/api';

/**
 * Hook to initialize and manage push notifications
 */
export const usePushNotifications = (isAuthenticated: boolean) => {
  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    // Initialize push notifications when user is authenticated
    const initializePush = async () => {
      try {
        // Request permission, register service worker, and subscribe
        const success = await pushNotificationService.initialize();
        
        if (success) {
          // Get subscription and register with backend
          const subscription = await pushNotificationService.getSubscriptionJSON();
          if (subscription) {
            try {
              await pushTokenAPI.registerWebPushToken(subscription);
              console.log('✅ Web push token registered with backend');
            } catch (error) {
              console.error('❌ Failed to register web push token:', error);
            }
          }
        } else {
          // Not a critical error - push notifications may not be supported
          console.log('ℹ️ Push notifications not available or not enabled');
        }
      } catch (error: any) {
        // Only log as error if it's not a known unsupported scenario
        if (error?.name !== 'AbortError' && !error?.message?.includes('Registration failed')) {
          console.error('❌ Failed to initialize push notifications:', error);
        } else {
          console.log('ℹ️ Push notifications not available:', error.message);
        }
      }
    };

    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      initializePush();
    }, 1000);

    return () => clearTimeout(timer);
  }, [isAuthenticated]);
};

